import React, { Component } from "react";
import { Route } from "react-router-dom";
import asyncComponent from "../../helpers/AsyncFunc";

const routes = [
  // {
  //   path: "",
  //   component: asyncComponent(() => import("../dashboard"))
  // },
  {
    path: "home",
    component: asyncComponent(() => import("../Main/HomeLanding"))
  },
  {
    path: "",
    component: asyncComponent(() => import("../MainDashboard"))
  },
   
  {
    path: "manageRequest",
    component: asyncComponent(() => import("../DSRManagement/viewRequestListing"))
  },
  {
    path: "addRequest",
    component: asyncComponent(() => import("../DSRManagement/AddRequestMaster"))
  },
  // {
  //   path: "CompanyMaster",
  //   component: asyncComponent(() => import("../CompanyMasterListing"))
  // },
  // {
  //   path: "companyMasterUserListing",
  //   component: asyncComponent(() => import("../CompanyMasterUserListing"))
  // },
  // {
  //   path: "SubscriptionMaster",
  //   component: asyncComponent(() => import("../SubscriptionMasterListing"))
  // },
  {
    path: "consents",
    component: asyncComponent(() => import("../ConsentListing"))
  },
  {
    path: "Profile",
    component: asyncComponent(() => import("../profile"))
  }
];

class AppRouter extends Component {
  render() {
    const { url, style } = this.props;
    return (
      <div style={style}>
        {routes.map(singleRoute => {
          const { path, exact, ...otherProps } = singleRoute;
          return (
            <Route
              exact={exact === false ? false : true}
              key={singleRoute.path}
              path={`${url}/${singleRoute.path}`}
              {...otherProps}
            />
          );
        })}
      </div>
    );
  }
}

export default AppRouter;
